import React, { PropTypes, Component } from "react";
import { NitroText, NitroButton, NitroHeading } from "nitro-components";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import styled from "styled-components";

import { media } from "style-utils";

import CustomRButtons from "./CustomRButtons";
import { EMAIL_NOTIFICATION_DISABLED } from "../content";

const MainContainer = styled.div`
	display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: baseline;
    padding: 24px;

      ${media.mobile`
       justify-content: center;
    `}

`;

class EmailSettings extends Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.onChange = this.onChange.bind(this);
	}

	onChange = (key, id, value) => {
		this.props.action(key, id, value);
	};

	render() {
		const { data } = this.props;
		const id = data.ContentKey;
		const emailNotifData = data.Email;
		const selectedValue = emailNotifData.Key;

		return (
			<MainContainer>
				<NitroHeading
					label={data.Heading}
					size="3"
					header
					variant={data.Enabled ? "secondary" : "base3"}
					noMargin
				/>
				{data.Enabled &&
					<CustomRButtons
						id={data.ContentKey}
						data={data.Email.Data}
						action={this.onChange}
						selectedValue={selectedValue}
					/>}

				{!data.Enabled &&
					<NitroText size="3" variant="base3">
						{EMAIL_NOTIFICATION_DISABLED}
					</NitroText>}
			</MainContainer>
		);
	}
}

EmailSettings.propTypes = {
	action: PropTypes.func,
	data: PropTypes.object
};

export default EmailSettings;



// WEBPACK FOOTER //
// ./src/features/notification/notification-settings/components/EmailSettings.js